import {
  AccountingAccessCredentials,
  accountingRequest,
} from 'src/helpers/accounting-access/accounting-access'
import {
  QuickBooksSyncingConfigDto,
  QuickbooksStatusResponse,
  UpdateQuickBooksSyncingConfig,
} from './quickbooks.type'

function regionHeaders(): Record<string, string> {
  const isUS = window.location.host.startsWith('us.')

  return { 'x-region': isUS ? 'region_us' : 'region_eu' }
}

export function getQuickbooksStatus({
  merchantId,
  credentials,
}: {
  merchantId: string
  credentials: AccountingAccessCredentials
}): Promise<QuickbooksStatusResponse> {
  return accountingRequest<QuickbooksStatusResponse>({
    method: 'get',
    url: `merchant/${merchantId}/quickbooks/status`,
    credentials,
    headers: regionHeaders(),
  })
}

export function disconnectQuickbooks({
  merchantId,
  credentials,
}: {
  merchantId: string
  credentials: AccountingAccessCredentials
}): Promise<void> {
  return accountingRequest<void>({
    method: 'post',
    url: `merchant/${merchantId}/quickbooks/disconnect`,
    credentials,
    data: {},
    headers: regionHeaders(),
  })
}

export function getQuickBooksSyncConfig({
  merchantId,
  credentials,
  refreshAccountsList,
}: {
  merchantId: string
  credentials: AccountingAccessCredentials
  refreshAccountsList?: boolean
}): Promise<QuickBooksSyncingConfigDto> {
  return accountingRequest<QuickBooksSyncingConfigDto>({
    method: 'get',
    url: `merchant/${merchantId}/quickbooks/sync-config`,
    credentials,
    params: { refreshAccountsList },
    headers: regionHeaders(),
  })
}

export function updateQuickBooksSyncConfig({
  merchantId,
  credentials,
  syncConfig,
}: {
  merchantId: string
  credentials: AccountingAccessCredentials
  syncConfig: UpdateQuickBooksSyncingConfig
}): Promise<void> {
  return accountingRequest<void>({
    method: 'put',
    url: `merchant/${merchantId}/quickbooks/sync-config`,
    credentials,
    data: syncConfig,
    headers: regionHeaders(),
  })
}
